import { PrismicLink, TextFromRichText } from './PrismicTypes';

export const GENERIC_INLINE_CTA = 'PrismicGenericTemplateDataBodyInlineCta';

export interface GenericInlineCtaPrimary {
  cta_heading: TextFromRichText;
  cta_body: TextFromRichText;
  cta_primary_button: TextFromRichText;
  cta_primary_button_link?: PrismicLink;
  cta_secondary_button?: TextFromRichText;
  cta_secondary_button_link?: PrismicLink;
}

export interface GenericInlineCtaContent {
  __typename: typeof GENERIC_INLINE_CTA;
  primary: GenericInlineCtaPrimary;
}
